import Api from 'requestapijs';
import { HEADER, API_URL } from '../config';
import { addWorkHistoryMutation, updateWorkHistoryCallMutation } from '../components/Calling/constant';
import { WorkHistoryMutationInput } from '../../schema';

export interface UpdateCallInput {
  workHistory: string;
  retailerId: number;
  callStatus: string;
  mobileNumber?: string;
  incrementAttempts?: boolean;
}

export class WorkHIstoryService {
  static instance: WorkHIstoryService;

  constructor() {
    if (WorkHIstoryService.instance) {
      return WorkHIstoryService.instance;
    } else {
      WorkHIstoryService.instance = this;
    }
  }

  add(data: WorkHistoryMutationInput, onSuccess: (reponse) => void, onError: (response) => void) {
    Api.graphql<{ input: WorkHistoryMutationInput }, any>(
      API_URL,
      { input: data },
      addWorkHistoryMutation,
      HEADER,
      (response) => {
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }

  /**
   * PERF-01: patch a single queue entry. Constant-size payload regardless of
   * how many retailers are in the town, and the server serialises concurrent
   * writers with a row lock.
   *
   * The server also reports its own failures inside a HTTP-200 payload
   * (`ok: false` + `errors`), which is why the success path re-checks rather
   * than assuming a 200 means it worked.
   */
  updateCall(data: UpdateCallInput, onSuccess: (response) => void, onError: (response) => void) {
    Api.graphql<UpdateCallInput, any>(
      API_URL,
      {
        workHistory: data.workHistory,
        retailerId: data.retailerId,
        callStatus: data.callStatus,
        mobileNumber: data.mobileNumber,
        incrementAttempts: data.incrementAttempts !== false,
      } as any,
      updateWorkHistoryCallMutation,
      HEADER,
      (response) => {
        const payload = response && response.data && response.data.updateWorkHistoryCall;
        if (!payload || !payload.ok) {
          return onError(
            (payload && payload.errors && payload.errors[0]) || 'Update failed',
          );
        }
        onSuccess(response);
      },
      (error) => {
        onError(error);
      },
    );
  }
}
